import { PortableText } from '@portabletext/react'
import { MdArrowForward } from 'react-icons/md'

import { InternalLink } from 'src/components/atoms/Link'
import { SanityImage } from 'src/components/atoms/SanityImage'
import TypographyRebrand from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { LatestPostRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'

import { viewBlogPostPath } from 'src/config/paths'
import { formatDate } from 'src/utils/date'
import { trpc } from 'src/utils/trpc'

const LatestPostSectionRebrand = ({ heading }: LatestPostRebrandResult) => {
  const { data: latestPost } = trpc.useQuery(['sanity.getLatestPost'])

  if (!latestPost || !latestPost.mainImage) return null

  const formattedDate = formatDate({
    date: latestPost.publishedAt,
    isUtc: true,
    format: 'DD MMM YYYY'
  })
  const href = viewBlogPostPath({
    routeParams: { slug: latestPost.slug.current }
  })

  return (
    <div className='container mx-auto px-4 lg:px-20'>
      {heading && (
        <div className='mb-8'>
          <TypographyRebrand variant='h4' color='forestDeep'>
            {heading}
          </TypographyRebrand>
        </div>
      )}

      <div className='flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12'>
        <InternalLink
          color='none'
          href={href}
          className='relative block aspect-[3/2] w-full overflow-hidden lg:w-3/5'
        >
          <SanityImage
            source={latestPost.mainImage}
            sourceWidth={780}
            sourceHeight={520}
            fill
            alt={latestPost.title}
            className='object-cover object-center'
          />
        </InternalLink>

        <div className='flex flex-col gap-4 lg:w-2/5'>
          <TypographyRebrand variant='eyebrow' color='forestDeep'>
            {formattedDate}
            {latestPost.estimatedReadingTime
              ? ` · ${latestPost.estimatedReadingTime} min read`
              : ''}
          </TypographyRebrand>

          <InternalLink color='none' href={href}>
            <TypographyRebrand variant='h3' color='forestDeep'>
              {latestPost.title}
            </TypographyRebrand>
          </InternalLink>

          {latestPost.summary && (
            <div className='text-forestDeep'>
              <PortableText
                components={{
                  block: {
                    normal: ({ children }) => (
                      <TypographyRebrand variant='body' color='forestDeep'>
                        {children}
                      </TypographyRebrand>
                    )
                  }
                }}
                value={latestPost.summary}
              />
            </div>
          )}

          <InternalLink
            color='none'
            href={href}
            className='inline-flex items-center gap-2 text-forestDeep hover:text-forestDeepHover'
          >
            <TypographyRebrand variant='eyebrow' color='forestDeep'>
              Read full story
            </TypographyRebrand>
            <MdArrowForward size={20} />
          </InternalLink>
        </div>
      </div>
    </div>
  )
}

export default LatestPostSectionRebrand
